import { Input, message } from 'antd';
import { useContext, useEffect, useState } from 'react';

import Button from '@/components/common/Button';
import { RightContext } from '@/components/RightProvider/context';
import { UseTranslateType } from '@/hooks/useTranslate';
import { queryRight } from '@/services/workspace';
import UserStore from '@/store/User';
import { EventNewID, fc_user_redeem_click } from '@/utils/eventlog/eventNewConfig';
import { trackEvent } from '@/utils/eventlog/logAdapter';

import { exchangeCode } from '../../UserAccount/service';
import CommonModal from '..';
import styles from './style.module.scss';

interface ExchangeCodeModalProps {
  from: fc_user_redeem_click['entrance'];
  onClose?: () => void;
}
interface ExchangeCodeProps {
  t: UseTranslateType;
  onClose: () => void;
  from: fc_user_redeem_click['entrance'];
}
const Content = ({ t, from, onClose }: ExchangeCodeProps) => {
  const rightContext = useContext(RightContext);
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const couponInfo = UserStore((state) => state.couponInfo);
  const getCouponInfo = UserStore((state) => state.getCouponInfo);
  useEffect(() => {
    getCouponInfo();
  }, []);

  const handleEffectFn = () => {
    // 兑换成功后
    // 1. 关闭新用户的左侧倒计时banner
    UserStore.getState().setShowNewUserCountDownBaner(false);
  };

  const onSubmit = async () => {
    if (!code) {
      message.warning(t('merror.code.start'));
      return;
    }
    if (couponInfo.type === 'ticket' && couponInfo.used) {
      message.warning(t('You have coupon cannot redeem it again'));
      return;
    }
    try {
      setLoading(true);
      let res: any = await exchangeCode(code);
      if (res.success) {
        if (res?.data?.type === 0) {
          trackEvent(EventNewID.REDEEMCODE_SUBMIT, { result: 1 });
          // 兑换码
          message.success(t('merror.code.success'));
          await rightContext.withUpdate();
          const res = await queryRight();
          if (res.success) {
            UserStore.getState().formatUserInfo(res.data);
          }
        } else if (res?.data?.type === 1) {
          // 优惠券
          let tip = t('get coupon tip', { tip: res?.data?.couponName });
          message.success(t('merror.code.success') + ', ' + tip);
        } else if (res?.data?.type === 2) {
          // 分销码
          message.success(t('merror.code.success'));
        }

        handleEffectFn();
        onClose();
      } else {
        trackEvent(EventNewID.REDEEMCODE_SUBMIT, { result: 0 });
        if (String(res.code) === '12301301') {
          message.error(t('get coupon error'));
          return;
        }
        if (String(res.code) === '12301302') {
          message.error(t('cannot get coupon again'));
          return;
        }
        // 已被使用
        if (String(res.code) === '1006035') {
          message.error(res.message);
          return;
        }
        // 无效/过期
        if (String(res.code === '1006036')) {
          message.error(t('merror.code.right'));
          return;
        } else {
          message.error(t('merror.code.error'));
          return;
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="py-[32px] px-[42px]">
        <Input
          className={styles['exchange-code-input']}
          onChange={(e) => {
            setCode(e.target.value);
          }}
        />
      </div>
      <div className="w-full h-[60px] flex justify-end items-center pl-[40px] pr-[16px]">
        <Button
          loading={loading}
          onClick={onSubmit}
          disabled={code.length < 1}
          className="w-[142px] h-[36px]"
        >
          {t('merror.operate.ok')}
        </Button>
      </div>
    </>
  );
};
export function exchangeCodeModalShow(options: ExchangeCodeModalProps) {
  CommonModal.show((t) => ({
    width: 800,
    title: t('merror.code.enter'),
    customPadding: {
      x: 0,
      y: 0,
    },
    footer: false,
    content: (close) => (
      <Content
        t={t}
        from={options.from}
        onClose={() => {
          close();
          options.onClose?.();
        }}
      />
    ),
  }));
}
